import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import { Row, Col, Collapse } from "reactstrap"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import classname from "classnames"

//i18n
import { useTranslation, withTranslation } from "react-i18next"

import { connect } from "react-redux"

const Navbar = props => {
  const { t } = useTranslation()

  const [product, setproduct] = useState(false)
  const [order, setorder] = useState(false)
  const [adv, setadv] = useState(false)
  const [isAdmin, setIsAdmin] = React.useState(false);

  const { roles } = useSelector(state => ({
    layoutType: state.Layout.layoutType,
    roles:
      state && state.Login && state.Login.userData && state.Login.userData.roles
        ? state.Login.userData.roles
        : null,
  }))

  React.useEffect(() => {
    if (roles && roles.toString().toLowerCase().includes("admin")) {
      setIsAdmin(true)
    } else {
      setIsAdmin(false)
    }
  }, [roles]);

  useEffect(() => {
    var matchingMenuItem = null
    var ul = document.getElementById("navigation")
    var items = ul.getElementsByTagName("a")
    removeActivation(items)
    for (var i = 0; i < items.length; ++i) {
      if (window.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  })

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement
      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        if (parent.classList.contains("active")) {
          parent.classList.remove("active")
        }
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    if (parent) {
      parent.classList.add("active") // li
      const parent2 = parent.parentElement
      parent2.classList.add("active") // li
      const parent3 = parent2.parentElement
      if (parent3) {
        parent3.classList.add("active") // li
        const parent4 = parent3.parentElement
        if (parent4) {
          parent4.classList.add("active") // li
          const parent5 = parent4.parentElement
          if (parent5) {
            parent5.classList.add("active") // li
            const parent6 = parent5.parentElement
            if (parent6) {
              parent6.classList.add("active") // li
            }
          }
        }
      }
    }
    return false
  }

  return (
    <React.Fragment>
      <div
        className="topnav"
        // style={{
        //   background:
        //     "linear-gradient(273.79deg, #095BA8 3.88%, #00A0DC 96.5%)",
        // }}
      >
        <div className="container-fluid">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav">
                <li className="nav-item">
                  <Link className="nav-link arrow-none" to="/dashboard">
                    <i className="mdi mdi-view-dashboard-outline me-2"></i>
                    <span>{t("dashboard_dashboard")}</span>
                  </Link>
                </li>

                {isAdmin && (
                  <li>
                    <Link className="nav-link arrow-none" to="/vendors">
                      <i className="mdi mdi-account-multiple me-2"></i>
                      <span>{t("vendors_vendors")}</span>
                    </Link>
                  </li>
                )}

                <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle arrow-none"
                    onClick={e => {
                      e.preventDefault()
                      setorder(!order)
                    }}
                    to="/#"
                  >
                    <i className="bx bx-box me-2"></i>
                    {t("orders_orders")}
                    <div className="arrow-down"></div>
                  </Link>
                  <div className={classname("dropdown-menu", { show: order })}>
                    <Link className="dropdown-item" to="/orders">
                      <i className="bx bx-box  me-2"></i>
                      <span>{t("orders_orders")}</span>
                    </Link>
                    <Link className="dropdown-item" to="/revenue">
                      <i className="bx bxs-down-arrow-square me-2"></i>
                      <span>{t("revenue_revenue")}</span>
                    </Link>
                    <Link className="dropdown-item" to="/delivery-men">
                      <i className="fas fa-motorcycle me-2"></i>
                      <span>{t("deliveryMen_deliveryMen")}</span>
                    </Link>
                    <Link className="dropdown-item" to="/disputes">
                      <i className="bx bx-user-voice me-2"></i>
                      <span>{t("disputes_disputes")}</span>
                    </Link>
                  </div>
                </li>
                <li className="nav-item">
                  <Link className="nav-link arrow-none" to="/coupons">
                    <i className="bx bxs-coupon me-2"></i>
                    <span>{t("coupons_coupons")}</span>
                  </Link>
                </li>

                <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle arrow-none"
                    onClick={e => {
                      e.preventDefault()
                      setproduct(!product)
                    }}
                    to="/#"
                  >
                    <i className="fas fa-boxes me-2"></i>
                    {t("products_products")}
                    <div className="arrow-down"></div>
                  </Link>
                  <div
                    className={classname("dropdown-menu", { show: product })}
                  >
                    <Link className="dropdown-item" to="/products">
                      <i className="fas fa-boxes me-2"></i>
                      <span>{t("products_products")}</span>
                    </Link>
                    <Link className="dropdown-item" to="/categories">
                      <i className="fas fa-shapes me-2"></i>
                      <span>{t("categories_categories")}</span>
                    </Link>
                  </div>
                </li>
                {/* <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle arrow-none"
                    onClick={e => {
                      e.preventDefault()
                      setadv(!adv)
                    }}
                    to="/#"
                  >
                    <i className="bx bx-collection me-2"></i>
                    {t("common_adv")}
                    <div className="arrow-down"></div>
                  </Link>
                  <div className={classname("dropdown-menu", { show: adv })}>
                    <Link className="dropdown-item" to="/campaigns">
                      <i className="mdi mdi-brightness-percent me-2"></i>
                      <span>{t("campaigns_campaigns")}</span>
                    </Link>
                    <Link className="dropdown-item" to="/offers">
                      <i className="bx bx-badge me-2"></i>
                      <span>{t("offers_offers")}</span>
                    </Link>
                  </div>
                </li> */}
                <li className="nav-item">
                  <Link className="nav-link arrow-none" to="/customers">
                    <i className="dripicons-user-group me-2"></i>
                    <span>{t("customers_customers")}</span>
                  </Link>
                </li>
              </ul>
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  )
}

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
}

const mapStatetoProps = state => {
  const { leftMenu } = state.Layout
  return { leftMenu }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(Navbar))
)
